import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const BENCHMARK_DEAL_FAILURE_STATE: Set<CubiqTS.OrderDealState> = new Set([
  CubiqTS.OrderDealState.ACK_TIME_OUT,
  CubiqTS.OrderDealState.NAK,
]);
